import { tabletMax, laptopMediumMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const FooterContainer = styled.footer`
  border-top: 1px solid ${(props) => props.theme.backgroundLight};
  border-bottom: 1px solid ${(props) => props.theme.backgroundLight};
  padding-top: 30px;
  padding-bottom: 90px;
`;

export const FooterInner = styled.div`
  gap: min(96px, 3vw);
  display: flex;
  justify-content: space-between;
  max-width: 2000px;
  margin: 0 auto;
  padding: 0 20px;

  @media screen and (${laptopMediumMax}) {
    flex-wrap: wrap;
    gap: initial;
  }

  @media screen and (${tabletMax}) {
    display: block;
  }
`;

export const Links = styled.div`
  display: flex;
  flex: 1;

  @media (${tabletMax}) {
    flex-direction: column;
  }
`;

export const LinksColumn = styled.div`
  flex-basis: 33.3%;
  h4 {
    color: ${(props) => props.theme.textDark};
    font-size: 14px;
  }

  ul {
    list-style: none;
    padding: 0;

    li {
      margin-bottom: 10px;
    }

    button,
    a {
      font-size: 14px;
      color: ${(props) => props.theme.textDark};

      &:hover {
        color: ${(props) => props.theme.backgroundMid};
      }
    }
  }

  @media screen and (${laptopMediumMax}) {
    flex-basis: 100%;
  }

  @media screen and (${tabletMax}) {
    text-align: center;
    margin-bottom: 30px;
  }
`;

export const EALogin = styled.li`
  @media (${tabletMax}) {
    display: none;
  }
`;

export const EALoginTablet = styled.li`
  display: none;

  @media (${tabletMax}) {
    display: initial;
  }
`;
